import {
	SET_FOOD_MENU,
	UPDATE_FOOD_QUANTITY,
	RESET_MENU,
	SET_TRANSACTIONS,
} from './actionTypes';

import { fetchMenu, fetchUserActiveTransactions } from "@api/menu";
import { fetchCart } from "@api/cart";
import { calculateInvoice } from "@api/invoice";

import {
	updateCartAction,
	calculateInvoiceAction,
	resetCartFoodAction,
	updateCartQuantityAction,
} from '../cart/actions';

const fetchMenuCart = (dayId, useStoreMenuData = false) => {
	return new Promise((resolve, reject) => {
		Promise.all([
			fetchCart(dayId),
			fetchMenu(dayId, useStoreMenuData),
			fetchUserActiveTransactions(),
		])
			.then(([cart, menu, transactions]) => {
				resolve({
					menu,
					cart,
					transactions,
				});
			})
			.catch(reject);
	});
};

export const getMenuCartAction = (dayId, useStoreMenuData = false) => (
	dispatch,
) => {
	dispatch(resetCartFoodAction());

	fetchMenuCart(dayId, useStoreMenuData).then(
		({ menu, cart, transactions }) => {
			const cartItems = cart.itemList;

			// prepare menu items for dispatch menu
			const foodItems = {};
			const foodList = {};
			const sideList = [];
			if (transactions && transactions.length > 0) {
				dispatch({
					type: SET_TRANSACTIONS,
					payload: transactions,
				});
			}
			const restaurantList = new Map()
			menu.forEach((category, mIndex) => {
				let hasMainFood = false;

				category.foodItemViewModels.forEach((food, fIndex) => {
					restaurantList.set(food.restaurantId , {name:food.restaurantName , id:food.restaurantId})
					foodItems[food.foodItemId] = { quantity: 0 };

					const stock =
						food.hasFoodStock && !food.sideMeal
							? food.foodStockQuantity || 0
							: null;

					foodList[food.foodItemId] = {
						...food,
						foodStockQuantity: stock,
					};
					menu[mIndex].foodItemViewModels[fIndex].foodStockQuantity = stock;

					if (food.sideMeal) {
						sideList.push({ ...food, foodStockQuantity: null }); // TODO: for sideMenu
					} else {
						hasMainFood = true;
					}
				});

				menu[mIndex].hasMainFood = hasMainFood;
			});

			const dispatchData = (calculateData = null) => {
				dispatch({
					type: SET_FOOD_MENU,
					payload: { foodItems, foodList, list: menu, sideList  , restaurantList },
				});

				dispatch(
					updateCartAction(
						calculateData?.data,
						cart.status,
						cart.companyAddressId,
						cart.companyAddressFloorId,
						calculateData?.paymentData,
					),
				);
			};

			// if cart has items then call calculate invoice, dispatch menu and dispatch cart
			if (cartItems.length) {
				calculateInvoice({
					dayId,
					foodItemIdQuantityList: cartItems,
				})
					.then((calculate) => {
						const userCartItems = calculate.data.itemList || [];

						userCartItems.forEach((item) => {
							if (foodItems[item.foodItemId]) {
								foodItems[item.foodItemId].quantity = item.quantity;
							}
						});

						dispatchData(calculate);
					})
					.catch((e) => {
						console.log(e);
						// if(e.err === )
						dispatchData();
					});
			} else {
				// if cart is empty then dispatch menu and cart
				dispatchData();
			}
		},
	);
};

export const updateFoodQuantityAction = (
	foodItemId,
	count = 1,
	callback = () => {},
) => (dispatch, getState) => {
	const state = getState();
	const quantityItem = state.menu.foodItems[foodItemId].quantity;
	const item = state.menu.foodList[foodItemId];

	const quantity = quantityItem + count;

	if (quantity >= 0) {
		dispatch({
			type: UPDATE_FOOD_QUANTITY,
			payload: {
				foodItemId,
				quantity,
			},
		});

		dispatch(updateCartQuantityAction(item, quantity));
	}

	dispatch(calculateInvoiceAction(callback));
};

export const emptyQuantityMenuAction = () => (dispatch, getState) => {
	const items = getState().menu.foodItems;

	const foodItems = {};
	Object.keys(items).forEach((id) => {
		const data = items[id];
		foodItems[id] = { ...data, quantity: 0 };
	});

	dispatch({
		type: SET_FOOD_MENU,
		payload: { foodItems },
	});
};

// export const getMenuFoodItems = menu => {
// 	const foodItems = {};

// 	menu.forEach(category => {
// 		category.foodItemViewModels.forEach(food => {
// 			foodItems[food.foodItemId] = getMenuFoodItem(food);
// 		});
// 	});

// 	return foodItems;
// };

export const getMenuFoodItem = (food) => {
	return {
		foodItemName: food.foodItemName,
		foodItemImage: food.foodItemImage,
		restaurantName: food.restaurantName,
		foodItemIngredients: food.foodItemIngredients,
		foodItemPrice: food.foodItemPrice,
	};
};

export const resetMenuAction = () => ({
	type: RESET_MENU,
	payload: true,
});
